module.exports = __webpack_public_path__ + "img/welfare-share.88ca75a6.png";